module.exports = __webpack_public_path__ + "img/0Q3A2361_L_BlackMatted_MockedUp.1274d9bb.jpg";